/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/execution/components/CommentPanel.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Execution Workspace
 *
 * DESCRIPTION:
 * Displays work execution comments and allows users
 * to add new comments.
 *
 * RESPONSIBILITIES
 * ----------------
 * ✓ Display comments
 * ✓ Add comment
 * ✓ View discussion history
 *
 ******************************************************************************/

import React, { useState } from "react";

export default function CommentPanel({

    comments = [],

    disabled = false,

    onAddComment,

}) {

    const [comment, setComment] = useState("");

    async function handleAdd() {
        const text = comment.trim();

        if (!text) {

            return;

        }

        await onAddComment?.(text);

        setComment("");

    }

    return (

        <div className="card shadow-sm border-0 mb-4">

            {/* ====================================================== */}
            {/* HEADER */}
            {/* ====================================================== */}

            <div className="card-header bg-white">

                <h5 className="mb-0">

                    Comments

                </h5>

            </div>

            {/* ====================================================== */}
            {/* BODY */}
            {/* ====================================================== */}

            <div
                className="card-body"
                style={{
                    maxHeight: 350,
                    overflowY: "auto",
                }}
            >

                {

                    comments.length === 0 && (

                        <div className="text-center text-muted py-4">

                            No comments available.

                        </div>

                    )

                }

                {

                    comments.map((row) => (

                        <div

                            key={row.id}

                            className="border rounded p-3 mb-3"

                        >

                            <div className="d-flex justify-content-between">

                                <strong>
                                    
                                    {row.commented_by_name || row.commented_by}
                                </strong>

                                <small className="text-muted">

                                    {row.created_at}

                                </small>

                            </div>

                            <div className="mt-2">
                                {row.comment_text}
                            </div>

                        </div>

                    ))

                }

            </div>

            {/* ====================================================== */}
            {/* FOOTER */}
            {/* ====================================================== */}

            <div className="card-footer bg-white">

                <div className="input-group">

                    <textarea

                        className="form-control"

                        rows={2}

                        placeholder="Add comment..."

                        disabled={disabled}

                        value={comment}

                        onChange={(e)=>

                            setComment(

                                e.target.value

                            )

                        }

                    />

                    <button

                        className="btn btn-primary"

                        disabled={disabled}

                        onClick={handleAdd}

                    >

                        <i className="fas fa-paper-plane me-2" />

                        Send

                    </button>

                </div>

            </div>

        </div>

    );

}